import { CFD_DEFAULT_IDLE_IMAGE } from '../constants'

export const getDefaultCfdImage = () => {
  return CFD_DEFAULT_IDLE_IMAGE
}

export const getReloadingImageUri = (imageUri) => {
  return `${imageUri}?timestamp=${new Date().getTime()}`
}
